/* eslint-disable quote-props */
import React from 'react';

export const IconSmallLink: React.FC = (props = {}) => (
    <svg height="24" width="24" fill="none" viewBox="0 0 24 24" {...props}>
        {props.children}
        <g fill="#000">
            <path d="M9.937 13.98l-.353-.354 1.414-1.415.354.354c.729.729 2.072.756 3.005-.177l1.532-1.532 1.414 1.414-1.532 1.532c-1.605 1.606-4.22 1.792-5.834.177z" />
            <path d="M17.598 6.319c-.729-.73-2.072-.756-3.005.177l-1.21 1.21a5.479 5.479 0 00-2.37-.46l2.165-2.165c1.606-1.605 4.22-1.79 5.834-.176 1.614 1.614 1.429 4.228-.177 5.833l-1.532 1.532-1.414-1.414 1.532-1.532c.933-.933.906-2.276.177-3.005zM14.062 9.854l.354.354-1.414 1.414-.354-.354c-.729-.728-2.072-.756-3.005.177L8.11 12.977l-1.414-1.414 1.532-1.532c1.605-1.605 4.219-1.791 5.833-.177z" />
            <path d="M6.402 17.515c.729.729 2.072.756 3.005-.177l1.21-1.21a5.476 5.476 0 002.37.46l-2.166 2.164c-1.605 1.606-4.219 1.791-5.833.177-1.615-1.614-1.429-4.228.176-5.834l1.533-1.532 1.414 1.414-1.532 1.532c-.933.934-.906 2.277-.177 3.006z" />
        </g>
    </svg>
);
